import { PublicClientApplication } from '@azure/msal-browser';

/**
 * Type definition for storing the Auth config.
 */
export type AuthConfig = {
  clientId: string;
  authority: string;
  scopes: string[];
  redirectUri: string;
  postLogoutRedirectUri: string;
  apiBaseUrl: string;
  publicClientApplication: PublicClientApplication;
};

/**
 * A const for storing the authentication config of the AuthProvider component. It will be set once and then locked, then used for api requests.
 */
export const authConfig: AuthConfig = {
  clientId: '',
  authority: '',
  scopes: [],
  redirectUri: '',
  postLogoutRedirectUri: '',
  apiBaseUrl: '',
  publicClientApplication: {} as PublicClientApplication,
};
